import React, { useState, useEffect, useRef } from 'react';
import {
    MapSlider
} from '../style/map_components'
import {
    BoxSpaceAround,
    BoxFlexStartTop
} from '../style/box'
import { Box, Slider, IconButton } from '@mui/material';
import { styled } from "@mui/system";

import {
    PlayArrow,
    Stop,
} from '@mui/icons-material'

// const Scrollbar = styled(Slider, {
//     shouldForwardProp: (prop) => prop !== "markIndex",
// })(({ markIndex = 6 }) => ({
//     [`& .MuiSlider-mark[data-index="${markIndex}"]`]: {
//         backgroundColor: "rgb(192, 37, 24)",
//         height: "10px",
//         width: "10px",
//         transform: "translate(-5px, -50%)",
//         borderRadius: "50%",
//     },
// }));
const Scrollbar = styled(Slider, {
    shouldForwardProp: (prop) => prop !== "markStyles",
  })(({ markStyles = [{ index: 12, color: "rgb(192, 37, 24)" }] }) => {
    const styles = {};
    markStyles.forEach(({ index, color }) => {
      styles[`& .MuiSlider-mark[data-index="${index}"]`] = {
        backgroundColor: color,
        height: "10px",
        width: "10px",
        transform: "translate(-5px, -50%)",
        borderRadius: "50%",
      };
    });
    return styles;
  });
const MapTimeSlider = (props) => {

    const [isPlay, setIsPlay] = useState(false)
    const [marks, setMarks] = useState([])

    const intervalRef = useRef(null);
    const datesRef = useRef(props.dates);
    // アイコンボタンのスタイル
    const ableButtonStyle = { color: '#fff', width: '1.3rem', height: '1.3rem' }

    // データが更新された時
    useEffect(() => {
        datesRef.current = props.dates
        // マーカー設定
        setSliderMarks()
    }, [props.dates])

    // マーカー設定
    const setSliderMarks = () => {
        let mark_array = []
        datesRef.current.map((item, i) => {
            mark_array.push({
                value: i,
                label: '',
            })
        })
        setMarks(mark_array)
    }
    const handleChange = (e) => {
        props.setChooseNum(e.target.value)
    }

    // 再生・停止
    const handlePlayPause = () => {
        setIsPlay(!isPlay);
    }

    // 自動再生ロジック
    useEffect(() => {
        if (isPlay) {
            intervalRef.current = setInterval(() => {
                props.setChooseNum((prev) =>
                    prev < datesRef.current.length - 1 ? prev + 1 : 0
                );
            }, 1000); // 1秒ごとに次へ
        } else {
            if (intervalRef.current) clearInterval(intervalRef.current);
        }
        // クリーンアップ
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [isPlay]);

    return (

        <BoxSpaceAround>
            <IconButton sx={{ margin: '0 10px', padding: 0 }} onClick={handlePlayPause}>
                {isPlay ?
                    <Stop sx={ableButtonStyle} />
                    :
                    <PlayArrow sx={ableButtonStyle} />
                }
            </IconButton>
            <Scrollbar
                // markIndex={props.markIndex}
                markStyles={props.markStyles}
                value={props.chooseNum}
                aria-label="Default"
                valueLabelDisplay="off"
                min={0}
                max={datesRef.current.length - 1}
                step={1}
                onChange={handleChange}
                marks={marks}
            />
        </BoxSpaceAround>
    )
}
export default MapTimeSlider;
